export function NavButton({ sectionKey, label, activeSection, scrolled, onClick }) {
  const isActive = activeSection === sectionKey;
  const base = "text-sm xl:text-base font-semibold whitespace-nowrap px-3 py-1.5 rounded-full border transition-all duration-300";
  const style = scrolled
    ? isActive ? "bg-blue-900 text-white border-blue-900 shadow-md" : "bg-white text-blue-900 border-blue-900 hover:bg-blue-900 hover:text-white"
    : isActive ? "bg-white/20 text-white border-white shadow-md" : "bg-white/10 text-white border-white/70 hover:bg-white/20 hover:border-white";
  return <button className={`${base} ${style}`} onClick={onClick}>{label}</button>;
}
